import { usePathParam, useRouter } from 'react-resource-router';
import useValidatePublicUser from './useValidatePublicUser';

/**
 * This hook is only intended to be used on paths that start with /username.
 *
 * @returns boolean - true if the path is valid, false otherwise
 */
const useValidateProfileIdPath = (): boolean => {
  const [routerState] = useRouter();
  const [pathProfileId] = usePathParam('pathProfileId');

  if (
    !routerState.location.pathname?.startsWith(`/user/profile/${pathProfileId}`)
  ) {
    throw new Error(
      'useValidatePublicUser hook can only be used on paths that start with /profile/username',
    );
  }

  return useValidatePublicUser(pathProfileId as string);
};

export default useValidateProfileIdPath;
